import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'src/app/config/api-routes';
import { LocalizationService } from './localization.service';

@Injectable({
  providedIn: 'root'
})
export class ManifestService {

  constructor(
    private localizationService: LocalizationService,
    private httpClient: HttpClient,
    private routes: ApiRoutes) { }

  public setManifest() {
    const language = this.localizationService.getStartingLanguage();
    this.httpClient.get(ApiRoutes.getRouteWithInjectedParams(this.routes.MANIFEST, [language])).subscribe(manifest => {
      const manifestFile = new Blob([JSON.stringify(manifest)], { type: "application/json" });
      let url = window.URL.createObjectURL(manifestFile);
      document.querySelector('#manifest-placeholder').setAttribute('href', url);
    });
  }
}
